import { render, staticRenderFns } from "./edit-phone.vue?vue&type=template&id=2aa66706&scoped=true&"
import script from "./edit-phone.vue?vue&type=script&lang=js&"
export * from "./edit-phone.vue?vue&type=script&lang=js&"
import style0 from "./edit-phone.vue?vue&type=style&index=0&id=2aa66706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa66706",
  null
  
)

export default component.exports